module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// /Users/gtirby/develop/~/core-js/library/modules/_add-to-unscopables.js
// module id = 332
// module chunks = 0